<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Inicio</strong>
          </CCardHeader>
          <CCardBody>
           
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>


export default {
  name: 'Dashboard',
  components: {
   
  },
  data () {
    return {

    }
  },
  methods: {
   
  }
}


</script>
